// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.accept-invite[data-v-85fee0f6] {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
